import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import templateService from "../../../services/jewelleryPlan/planTemplateService";

export const createTemplateThunk = createAsyncThunk(
  "templates/createTemplate",
  async (templateData, { rejectWithValue }) => {
    try {
      console.log("=== CREATE TEMPLATE THUNK ===");
      console.log("Data received in thunk:", templateData);

      // Validate required fields before sending
      const requiredFields = [
        "name",
        "code",
        "type",
        "tenureMonths",
        "minInstallment",
        "maxInstallment",
        "terms",
      ];

      const missingFields = requiredFields.filter(
        (field) => !templateData[field]
      );

      if (missingFields.length > 0) {
        console.error("Missing required fields in thunk:", missingFields);
        return rejectWithValue(
          `Missing required fields: ${missingFields.join(", ")}`
        );
      }

      const response = await templateService.createTemplate(templateData);
      return response;
    } catch (error) {
      console.error("Thunk error:", error);
      const errorMessage = error.response?.data?.error || error.message;
      return rejectWithValue(errorMessage);
    }
  }
);

export const getAllTemplatesThunk = createAsyncThunk(
  "templates/getAllTemplates",
  async (filters, { rejectWithValue }) => {
    try {
      const response = await templateService.getAllTemplates(filters);
      return response;
    } catch (error) {
      const errorMessage = error.response?.data?.error || error.message;
      return rejectWithValue(errorMessage);
    }
  }
);

export const getTemplateByIdThunk = createAsyncThunk(
  "templates/getTemplateById",
  async (templateId, { rejectWithValue }) => {
    try {
      const response = await templateService.getTemplateById(templateId);
      return response;
    } catch (error) {
      const errorMessage = error.response?.data?.error || error.message;
      return rejectWithValue(errorMessage);
    }
  }
);

export const updateTemplateByIdThunk = createAsyncThunk(
  "templates/updateTemplateById",
  async ({ templateId, templateData }, { rejectWithValue }) => {
    try {
      console.log("=== UPDATE TEMPLATE THUNK ===");
      console.log("Template ID:", templateId);
      console.log("Template Data:", templateData);

      const response = await templateService.updateTemplateById(
        templateId,
        templateData
      );
      return response;
    } catch (error) {
      console.error("Update thunk error:", error);
      const errorMessage = error.response?.data?.error || error.message;
      return rejectWithValue(errorMessage);
    }
  }
);

export const deleteTemplateByIdThunk = createAsyncThunk(
  "templates/deleteTemplateById",
  async (templateId, { rejectWithValue }) => {
    try {
      const response = await templateService.deleteTemplateById(templateId);
      return response;
    } catch (error) {
      const errorMessage = error.response?.data?.error || error.message;
      return rejectWithValue(errorMessage);
    }
  }
);

export const clearTemplateError = createAction("templates/clearTemplateError");
